<div id="logout-wrapper" role="main">
  <mat-card id="logout-container">
    <mat-card-title role="heading" aria-level="2">{{'logout.you-have-been' | translate}}</mat-card-title>
    <mat-card-content>
      <button mat-raised-button color="primary" routerLink="/dashboard">{{'logout.go-to-dashboard' | translate}}</button>
    </mat-card-content>
  </mat-card>
</div>
